export default {
    path: 'account',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/common/CommonList'),
    meta: {title:'账号管理'}
}